import { Add, Remove } from "@mui/icons-material";
import {
  Box,
  Button,
  Container,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import SEO from "../../components/SEO";
import { setTabIndex } from "../../ReduxStore/UserSlice";
import NextStepCard from "../Home/NextStepCard";

const faqs = [
  {
    question:
      "What is an MSME loan for a new business, and how can Dequitec help me get one?",
    answer:
      "Dequitec helps new businesses get MSME loans by connecting them with the right lenders and managing the end-to-end process. We make it simple with fast checks, expert assistance, and fast approvals - no hassle!",
  },
  {
    question:
      "How do I qualify for an unsecured business loan in Delhi with Dequitec’s assistance?",
    answer:
      "To get an unsecured business loan in Delhi with Dequitec, you just need a registered business, steady income, and basic documents. We make it simple by quickly checking your eligibility, matching you with the right lender, and guiding you through the approval process, no collateral needed.",
  },
  {
    question:
      "Why should I choose a business loan consultant instead of applying directly to banks?",
    answer:
      "A business loan consultant helps you find the best loan faster by connecting you with multiple lenders, improving your approval chances, and handling all the paperwork. It’s quicker, easier, and often gets you better terms than going directly to a bank.",
  },
  {
    question:
      "How can Dequitec’s loan eligibility checker help me find the right funding options?",
    answer:
      "Our loan eligibility checker quickly reviews your business profile and financial details to match you with the most suitable funding options from trusted lenders. It saves you time, eliminates guesswork, and helps you find the right loan faster.",
  },
  {
    question:
      "What are the benefits of taking a small business loan in Faridabad through Dequitec?",
    answer:
      "Small businesses in Faridabad get quick access to trusted lenders, competitive interest rates, and fast approvals. We have in-depth knowledge of the local market, which makes the loan process simple, including minimal paperwork and full support at every step.",
  },
  {
    question:
      "How does the business loan eligibility calculator on Dequitec work?",
    answer:
      "Just by entering a few simple details such as  Nature of Entity, Nature of Business, How old is the business, revenue, End use of funds, and Any history of EMI delay or Default. The calculator will instantly show how much loan you’re eligible for, making it easier to plan your next steps.",
  },
  {
    question:
      "Can I get a business loan without collateral for a startup or MSME?",
    answer:
      "Yes, we help startups and MSMEs get unsecured business loans based on their credit score and business potential. You don’t need to provide any collateral or assets as security.",
  },
  {
    question:
      "What documents are required for applying for a new business loan through Dequitec?",
    answer:
      "These are the documents you need:\n\nPAN card\n\nAadhaar card\n\nBusiness registration proof\n\nBank statements (last 6–12 months)\n\nITR or financial statements. Additional documents may vary depending on the lender.",
  },
  {
    question:
      "Does Dequitec assist with improving loan eligibility for small business owners?",
    answer:
      "Yes, we provide guidance on improving your credit score, organizing financials, and choosing the right loan product to boost your eligibility.",
  },
  {
    question:
      "In how many days can I get approval for a small business or MSME loan with Dequitec’s help?",
    answer:
      "Loan approval times with us depend on your business profile and how quickly you submit the required documents. Our expert support and streamlined process help move things along faster than traditional methods.",
  },
];

const FAQ = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openIndex, setOpenIndex] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Box>
      <SEO
        title="FAQs on MSME Loans & Unsecured Business Loans | Dequitec"
        description="Find answers about working capital loans, loan against property, and business funding. Get expert insights to make informed financial decisions."
        canonical="https://www.dequitec.com/faq"
      />
      <Container
        maxWidth="lg"
        sx={{
          marginTop: { xs: 3, sm: 4, md: 5 },
          marginBottom: { xs: 3, sm: 4, md: 5 },
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            mb: { xs: 3, md: 4 },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
            <Box
              sx={{
                width: "40px",
                height: "2px",
                backgroundColor: "#0052CC",
                mr: 1,
              }}
            ></Box>
            <Typography
              variant="body2"
              color="primary"
              fontWeight="600"
              sx={{ fontSize: "14px" }}
            >
              FAQs
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "center", md: "flex-start" },
              width: "100%",
              mt: 1,
            }}
          >
            <Box
              sx={{
                maxWidth: { xs: "100%", md: "55%" },
                mb: { xs: 3, md: 0 },
              }}
            >
              <Typography
                variant="h4"
                fontWeight="700"
                gutterBottom
                sx={{
                  fontSize: { xs: "22px", sm: "26px", md: "32px" },
                  color: "#212B36",
                  mb: 1.5,
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Got Questions? We're Here to Help!
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                  fontSize: { xs: "14px", sm: "15px", md: "16px" },
                  lineHeight: 1.6,
                  color: "#637381",
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Have questions? We've got answers. Find quick solutions to the
                most commonly asked queries about our loan services, application
                process, and platform features.
              </Typography>
            </Box>
            <Box
              sx={{
                maxWidth: { xs: "85%", sm: "60%", md: "40%", lg: "35%" },
                display: "flex",
                justifyContent: "center",
                order: { xs: -1, md: 2 },
                mb: { xs: 3, md: 0 },
              }}
            >
              <img
                src="/FAQSection.png"
                alt="FAQ illustration"
                style={{
                  width: "100%",
                  maxWidth: "280px",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            paddingX: { xs: 1, sm: 2, lg: 6 },
            paddingY: { xs: 1, sm: 2 },
          }}
        >
          <Typography
            variant="h6"
            fontWeight="bold"
            textAlign="center"
            gutterBottom
            sx={{
              fontSize: { xs: "1.1rem", sm: "1.3rem", md: "1.5rem" },
              marginBottom: { xs: 3, md: 4 },
              display: { xs: "block", md: "block" },
            }}
          >
            Frequently Asked Questions
          </Typography>

          {faqs.map((faq, index) => (
            <Box
              key={index}
              sx={{
                marginBottom: { xs: 1.5, md: 2 },
                paddingX: { xs: 1, sm: 3, md: 6, lg: 1 },
                width: "100%",
              }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                sx={{
                  marginBottom: 0,
                  gap: 1,
                  cursor: "pointer",
                }}
                onClick={() => handleToggle(index)}
              >
                <Typography
                  color="#004AAD"
                  fontWeight="bold"
                  sx={{
                    cursor: "pointer",
                    fontSize: { xs: "13px", sm: "15px", md: "18px" },
                    fontWeight: 600,
                    wordWrap: "break-word",
                    maxWidth: { xs: "85%", sm: "90%" },
                  }}
                >
                  {faq.question}
                </Typography>
                <IconButton
                  sx={{
                    fontSize: { xs: "18px", sm: "22px", md: "24px" },
                    padding: 0,
                    minWidth: "auto",
                    marginTop: "0px",
                  }}
                >
                  {openIndex === index ? <Remove /> : <Add />}
                </IconButton>
              </Box>
              {openIndex === index && (
                <Typography
                  color="#000000"
                  sx={{
                    marginTop: 1,
                    fontSize: { xs: "12px", sm: "13px", md: "14px" },
                    fontWeight: 300,
                    lineHeight: 1.6,
                    whiteSpace: "pre-line",
                  }}
                >
                  {faq.answer}
                </Typography>
              )}
              <Divider sx={{ marginTop: 2 }} />
            </Box>
          ))}
        </Box>

        <Box
          sx={{
            paddingX: { xs: 1, sm: 3, md: 4, lg: 12 },
            paddingY: { xs: 1, sm: 2 },
            marginTop: { xs: -2, md: -5 },
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              padding: { xs: 2, sm: 3, md: 4 },
              backgroundImage: "url(./QAbanner.png)",
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: "10px",
              marginTop: { xs: 4, sm: 5, md: 6 },
            }}
          >
            <Typography
              variant="h5"
              fontWeight="bold"
              gutterBottom
              sx={{
                fontSize: { xs: "18px", sm: "20px", md: "24px" },
              }}
            >
              Still have a question?
            </Typography>
            <Typography
              textAlign="center"
              variant="subtitle2"
              fontStyle="italic"
              sx={{
                maxWidth: "600px",
                margin: "0 auto",
                marginBottom: { xs: 2, md: 3 },
                color: "#333333",
                fontSize: { xs: "10px", sm: "12px", md: "14px" },
                padding: { xs: "0 10px", sm: 0 },
              }}
            >
              You can submit your question or request through our contact team.
              Please provide as much detail as possible so that we can assist
              you effectively.
            </Typography>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#004AAD",
                color: "#FFFFFF",
                padding: { xs: "8px 16px", md: "10px 20px" },
                textTransform: "none",
                fontSize: { xs: "0.7rem", sm: "0.75rem", md: "0.8rem" },
                width: { xs: "130px", md: "150px" },
                "&:hover": { backgroundColor: "#003B7A" },
              }}
              onClick={() => {
                window.scrollTo(0, 0);
                dispatch(setTabIndex(6));
                navigate("/contact-us");
              }}
            >
              Get in touch
            </Button>
          </Box>
        </Box>
      </Container>
      <NextStepCard />
    </Box>
  );
};

export default FAQ;
